import React from 'react';

/**
 * ImageSection — full-bleed image + copy, image anchored flush to the browser edge.
 * The inner-edge fade is written INLINE (maskImage + WebkitMaskImage) so no
 * build step can strip it. Do not replace it with an overlay, pseudo-element,
 * background-image, or opacity gradient.
 *
 * side="left"  → image on the left, fades `to right` toward the copy
 * side="right" → image on the right, fades `to left`
 * No `image` and no `placeholder` → renders full-width text (no empty column).
 */
export function fadeMask(side) {
  const dir = side === 'right' ? 'to left' : 'to right';
  const g = `linear-gradient(${dir}, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 45%, rgba(0,0,0,0) 100%)`;
  return { maskImage: g, WebkitMaskImage: g };
}

export default function ImageSection({
  side = 'left',
  image = null,          // e.g. "/brand/what.webp"
  slot = '',             // data-slot label for placeholders
  alt = '',
  background = 'var(--bg)',
  className = '',
  eager = false,
  testId,
  children,
}) {
  if (!image) {
    return (
      <section className={`band ${className}`} style={{ background }} data-testid={testId}>
        <div className="wrap">{children}</div>
      </section>
    );
  }
  return (
    <section className={`bleed img-${side} ${className}`} style={{ background }} data-testid={testId}>
      <div className={`imgcol side-${side}`} style={fadeMask(side)} data-slot={slot}>
        <img src={image} alt={alt} loading={eager ? 'eager' : 'lazy'} />
      </div>
      <div className="copy">{children}</div>
    </section>
  );
}
